import { render, staticRenderFns } from "./bill-data-list.vue?vue&type=template&id=0ff56e4e&scoped=true&"
import script from "./bill-data-list.vue?vue&type=script&lang=js&"
export * from "./bill-data-list.vue?vue&type=script&lang=js&"
import style0 from "./bill-data-list.vue?vue&type=style&index=0&id=0ff56e4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff56e4e",
  null
  
)

export default component.exports